module.exports = __webpack_public_path__ + "img/h-photo-icon.82c444b2.png";